import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import {MatToolbar, MatToolbarModule} from '@angular/material/toolbar';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { MatSortModule } from '@angular/material/sort';
import { TranslateModule } from '@ngx-translate/core';
import {projektverwaltungReducer} from './store/reducer/projektverwaltung.reducer';
import {ProjektService} from './projekt.service';
import {ProjektverwaltungPageComponent} from './components/projekt-page/projektverwaltung-page.component';
import {ProjektEffects} from './store/effects/projekt.effects';
import {ProjektTableComponent} from './components/projekt-table/projekt-table.component';
import {ProjektFormdialogComponent} from './components/projekt-form-dialog/projekt-formdialog.component';
import {ProjektFilterComponent} from './components/projekt-filter/projekt-filter.component';
import {MatTreeModule} from '@angular/material/tree';
import {CdkTreeModule} from '@angular/cdk/tree';
import {ProjektExpandableTableComponent} from './components/projekt-expandable-table/projekt-expandable-table.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {ProjektStufeFormdialogComponent} from './components/projektstufe-form-dialog/projektstufe-formdialog.component';
import {SharedModule} from '../../shared.module';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {MatRadioModule} from '@angular/material/radio';

@NgModule({
    imports: [
        StoreModule.forFeature('projektverwaltung', projektverwaltungReducer),
        EffectsModule.forFeature([ProjektEffects]),
        MatTableModule,
        CommonModule,
        TranslateModule,
        MatToolbarModule,
        FlexLayoutModule,
        MatListModule,
        MatCardModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        ReactiveFormsModule,
        MatSortModule,
        MatTreeModule,
        CdkTreeModule,
        FormsModule,
        MatCheckboxModule,
        SharedModule,
        MatTooltipModule,
        TooltipModule,
        MatRadioModule,

    ],
    providers: [ProjektService],
    declarations: [
      ProjektverwaltungPageComponent,
      ProjektTableComponent,
      ProjektFormdialogComponent,
      ProjektFilterComponent,
      ProjektExpandableTableComponent,
      ProjektStufeFormdialogComponent,
    ],
})
export class ProjektverwaltungModule {}
